import { Box } from '@mui/material'
import { useCropModalContext, useCropModalContextDispatch, setPropagationCode } from '../context/crop-modal-context'
import { CropScheduleControls } from './crop-schedule-controls'
import { CropTimelinePreview } from './crop-timeline-preview'
import { CropTaskChips } from './crop-task-chips'

export const CropScheduleSection = ({
  cropPhaseTypes,
  cropGrowthTypes,
  cropLifecycleTypes,
  availableCropPropagationTypes,
  effectivePhaseCodes,
  effectiveTaskCodes,
  effectivePropagationCodes,
  activePropagationCode,
  previewScheduleData,
  timelineScrollConfig,
  defaultPhases,
  defaultTasks,
  adjustedPhases,
  adjustedTasks,
  selectedPhaseCodes,
  frostDates,
  handlers,
}) => {
  const { cropId, open, species, isCustomCrop } = useCropModalContext()
  const dispatch = useCropModalContextDispatch()

  // Only render for create mode
  if (cropId || !open) return null

  const handlePropagationChange = (newValue) => {
    dispatch(setPropagationCode({ propagationCode: newValue }))
  }

  const enrichedHandlers = { ...handlers, handlePropagationChange }

  return (
    <Box sx={{ pt: { xs: 1, sm: 0, md: 1 }, pb: '0.5rem' }}>
      <CropScheduleControls
        cropPhaseTypes={cropPhaseTypes}
        cropGrowthTypes={cropGrowthTypes}
        cropLifecycleTypes={cropLifecycleTypes}
        availableCropPropagationTypes={availableCropPropagationTypes}
        effectivePhaseCodes={effectivePhaseCodes}
        activePropagationCode={activePropagationCode}
        handlers={enrichedHandlers}
      />

      <CropTimelinePreview
        previewScheduleData={previewScheduleData}
        timelineScrollConfig={timelineScrollConfig}
        defaultPhases={defaultPhases}
        defaultTasks={defaultTasks}
        adjustedPhases={adjustedPhases}
        adjustedTasks={adjustedTasks}
        selectedPhaseCodes={selectedPhaseCodes}
        frostDates={frostDates}
        onPhaseAdjust={handlers.handlePhaseAdjust}
        onTaskAdjust={handlers.handleTaskAdjust}
        onReset={handlers.handleResetWithPhases}
      />

      {(species || isCustomCrop) && (
        <CropTaskChips
          effectiveTaskCodes={effectiveTaskCodes}
          effectivePhaseCodes={effectivePhaseCodes}
          effectivePropagationCodes={effectivePropagationCodes}
          activePropagationCode={activePropagationCode}
          cropPhaseTypes={cropPhaseTypes}
          onTaskToggle={handlers.handleTaskToggle}
        />
      )}
    </Box>
  )
}
